import { MessageSquareQuote } from "lucide-react";
import type { ComponentProps } from "react";

export function Logo(props: ComponentProps<typeof MessageSquareQuote>) {
  return <MessageSquareQuote {...props} />;
}
